import { message } from 'antd';

import { call, put, takeLatest, all, fork } from 'redux-saga/effects'
import { CHANGE_PASSWORD, FETCH_USER_CONFIGURATIONS, SET_DEFAULT_CONFIGURATIONS, SET_SESSION_ROLE, SET_SESSION_ROLE_SUCCESS, UPDATE_USER_CONFIGURATIONS, fetchUserAllowedRisWithMips, userSignOut} from "../actions/Auth";
import { HIDE_MODAL, SUBMIT_START, SUBMIT_ERROR,SUBMIT_STOP } from "../actions/userModalActions";
import { setSessionRoleAPI, changePasswordAPI, fetchUserConfigurationsAPI, updateUserConfigurationsAPI } from "../../services/users-service";
import { history } from '../store';

function* changePassword({ user }) {
    try {
        yield put({ type: SUBMIT_START })
        const response = yield call(changePasswordAPI, user);
        if (response.success) {
            yield put({ type: HIDE_MODAL })
            message.success('Your password changed successfully.');
            yield put(userSignOut());
            yield put({ type:SUBMIT_STOP });
        } else {
            yield put({ type: SUBMIT_ERROR })
            message.error(response.data);
        }
    } catch (error) {
        yield put({ type: SUBMIT_ERROR })
        message.error('Error occurred while changing password!');
    }
}

function* setUserSessionRole({ payload }) {
    try {
        const response = yield call(setSessionRoleAPI, payload);
        if (response.success) {
            yield put(fetchUserAllowedRisWithMips(payload.role));
            yield put({ type: SET_SESSION_ROLE_SUCCESS, role: payload.role });
            history.push({ pathname: '/' });
        } else {
            message.error('Failed to change session role!');
        }
    } catch (error) {
        message.error('Failed to change session role!');
    }
}

function* getUserConfigurations({  }) {
    try {
        const response = yield call(fetchUserConfigurationsAPI);
        if (response.success) {
            let configurations ={};
            response.data.forEach(config => {
                if(config.type === "int"){
                    configurations[config.name]= parseInt(config.value);
                }else if(config.type === "boolean"){
                    configurations[config.name]= JSON.parse(config.value);
                } else {
                    configurations[config.name]= config.value;
                }
            });
            yield put({ type: SET_DEFAULT_CONFIGURATIONS, configurations });
        } else {
            message.error('Failed to fetch user configurations!');
        }
    } catch (error) {
        message.error('Failed to fetch user configurations!');
    }
}

function* updateUserConfigurations({  payload }) {
    try {
        const { configurations, callback } = payload;
        const response = yield call(updateUserConfigurationsAPI, configurations);
        if (response.success) {
            let newconfigurations ={};
            response.data.forEach(config => {
                if(config.type === "int"){
                    newconfigurations[config.name]= parseInt(config.value);
                }else if(config.type === "boolean"){
                    newconfigurations[config.name]= JSON.parse(config.value);
                } else {
                    newconfigurations[config.name]= config.value;
                }
            });
            callback();
            yield put({ type: SET_DEFAULT_CONFIGURATIONS, configurations: newconfigurations });
        } else {
            callback();
            message.error('Failed to update user configurations!');
        }
    } catch (error) {
        message.error('Failed to update user configurations!');
    }
}

function* authUserWatcher() {
    yield takeLatest(FETCH_USER_CONFIGURATIONS, getUserConfigurations)
    yield takeLatest(UPDATE_USER_CONFIGURATIONS, updateUserConfigurations)
    yield takeLatest(CHANGE_PASSWORD, changePassword)
    yield takeLatest(SET_SESSION_ROLE, setUserSessionRole)
}


export default function* rootSaga() {
    yield all([fork(authUserWatcher)]);
}
